import images from '@assets/images/index'
import { defaultDropdownFilter } from '@hooks/useAssessmentDropdownFilters'
import {
  GetAPIparams,
  schoolLabels,
  teamLabels
} from '@utils/assessmentReportUtils'

import { useLocation, useNavigate } from '@suntex.core/nav'
import { isAuthenticated, useAuth } from '@suntex.fim/auth/react'
import { $EntityLevel, EntityLevel } from '@suntex.fim/enums'
import { getFlags } from '@suntex.fim/flags'
import { useOptionalTeamInfo } from '@suntex.fim/team'
import { Dropdown } from '@suntex.fim/ui'

const PATH_ID_INDEX = 2
const PATH_REPORT_TYPE_INDEX = 4

/**
 * returns JSX for report
 */
function Report() {
  const location = useLocation()
  const team = useOptionalTeamInfo()
  const { login } = useAuth(isAuthenticated)
  const test = location.pathname.split('/')
  const navigate = useNavigate()
  const { level } = GetAPIparams(
    login.entityLevel === EntityLevel.School &&
      location.pathname.includes('school'),
    defaultDropdownFilter,
    login.entityLevel === EntityLevel.Player &&
      location.pathname.includes('player')
  )
  const labels = level === EntityLevel.School ? schoolLabels : teamLabels
  let id = test[PATH_ID_INDEX]
  if (level === EntityLevel.Team) {
    id = String(team?.id)
  }
  const items = Object.entries(labels)
    .filter(
      ([key]) =>
        getFlags().player.goals ||
        (key !== 'goals-index' && key !== 'algebra-goals-metric')
    )
    .map(([key, value]) => ({
      key,
      label: value,
      onClick: () => {
        navigate(
          `/${$EntityLevel.describe(level).slug}/${id}/assessment-report/${key}`
        )
      }
    }))
  const label = labels[test[PATH_REPORT_TYPE_INDEX]]
  return (
    <Dropdown
      label={label}
      menu={{ items }}
      key={test[PATH_REPORT_TYPE_INDEX]}
      className={'reports-dropdown print-hidden'}
      overlayClassName="reports-dropdown"
      ariaLabel="Assessment report type selection"
      icon={<images.ArrowSquareDown />}
    />
  )
}

export default Report
